import React from 'react';
import { MenuItemProps } from '@mui/material';
import * as Styled from './menu-item.styles';

const MenuItem: React.FC<MenuItemProps> = React.forwardRef((props, ref) => {
  return <Styled.MenuItem ref={ref} {...props} />;
});

export default React.memo(MenuItem);
